import { supabase } from './supabase'
import type { Locale } from './i18n'

type EventName='signed_in'|'game_account_created'|'account_switched'|'inventory_updated'|'quick_entry_started'|'trade_search'|'trade_request_sent'|'trade_request_responded'|'language_changed'|'data_exported'|'account_deleted'
const SESSION_KEY='clash_cards_session_id'
let platform:'web'|'ios'|'android'='web'
function sessionId(){let id=sessionStorage.getItem(SESSION_KEY);if(!id){id=crypto.randomUUID();sessionStorage.setItem(SESSION_KEY,id)}return id}
export function setAnalyticsPlatform(value:'web'|'ios'|'android'){platform=value}
export function track(eventName:EventName,locale:Locale,gameAccountId:string|null=null,properties:Record<string,string|number|boolean>={}){
  if(new URLSearchParams(location.search).get('demo')==='1')return
  void supabase.rpc('product_event_track',{p_event_name:eventName,p_session_id:sessionId(),p_game_account_id:gameAccountId,p_locale:locale,p_platform:platform,p_properties:properties}).then(()=>undefined)
}
